<div class="custom-block-width" style="padding: 0 15px">
  <h4 class="modal-header header-title">
    {{ data.drugName }}
    <span class="close-icon">
      <mat-icon (click)="cancel()">close</mat-icon>
    </span>
  </h4>

  <div class="custom-dialog-width">
    <div class="map-info">
      <!-- BRAND SECTION -->
      <p class="title-11 mb-0 text-w-700">Brand</p>

      @if (brandPricing?.memberResponsibilityEstimate$ | async; as response) {
        @if (response.status === 'HARD_REJECT') {
          <ng-container *ngTemplateOutlet="
                    rejectMsgTemplate;
                    context: { rejectMsg: brandPricing.rejectMessage }
                  "></ng-container>
        }
        @if (response.status === 'SUCCESS') {
          <ng-container *ngTemplateOutlet="
                    rejectMsgTemplate;
                    context: { rejectMsg: brandPricing.rejectMessage }
                  "></ng-container>
          <ng-container *ngTemplateOutlet="
                    pricingTemplate;
                    context: { memberResponsibility: response?.patientPay }
                  "></ng-container>
        }
        @if (response.status === 'REJECT_WITH_RETURN_PRICE') {
          @if (response.success) {
            <ng-container *ngTemplateOutlet="
                      rejectMsgTemplate;
                      context: { rejectMsg: brandPricing.rejectMessage }
                    "></ng-container>
            <ng-container *ngTemplateOutlet="
                      pricingTemplate;
                      context: {
                        memberResponsibility: response?.patientPay,
                      }
                    "></ng-container>
        } @else {
          <p class="reject-msg text-danger d-flex justify-content-between">
            Thank you for using our pricing tool, we are unable to return price for this medication.
          </p>
        }
      }
    } @else {
      <div class="field-loader">
        <div class="loading-bar"></div>
      </div>
    }

    <!-- GENERIC SECTION -->
    <p class="title-11 mb-0 text-w-700">Generic</p>

    @if (genericPricing?.memberResponsibilityEstimate$ | async; as response) {
      @if (response.status === 'HARD_REJECT') {
          <ng-container *ngTemplateOutlet="
                    rejectMsgTemplate;
                    context: { rejectMsg: genericPricing.rejectMessage }
                  "></ng-container>
      }
      @if (response.status === 'SUCCESS') {
          <ng-container *ngTemplateOutlet="
                    rejectMsgTemplate;
                    context: { rejectMsg: genericPricing.rejectMessage }
                  "></ng-container>
          <ng-container *ngTemplateOutlet="
                    pricingTemplate;
                    context: { memberResponsibility: response?.patientPay }
                  "></ng-container>
      }
      @if (response.status === 'REJECT_WITH_RETURN_PRICE') {
        @if (response.success) {
            <ng-container *ngTemplateOutlet="
                      rejectMsgTemplate;
                      context: { rejectMsg: genericPricing.rejectMessage }
                    "></ng-container>
            <ng-container *ngTemplateOutlet="
                      pricingTemplate;
                      context: {
                        memberResponsibility:  response?.patientPay,
                      }
                    "></ng-container>
      } @else {
        <p class="reject-msg text-danger d-flex justify-content-between">
          Thank you for using our pricing tool, we are unable to return price for this medication.
        </p>
      }
    }
  } @else {
    <div class="field-loader">
      <div class="loading-bar"></div>
    </div>
  }

  @if (showMemberResponsibilityNote$ | async) {
    <div>
      <p class="reject-text-note mb-2"><b>Member Responsibility</b> is an estimate. The amount may change based on when you fill your medication.</p>
    </div>
  }

  <!-- PHARMACY DETAILS -->
  <h3>Pharmacy Details</h3>
  <div class="mat-row pharmacy-details" fxLayout="row">
    <div class="mat-6">
      <label>Pharmacy Name</label>
      <p class="value">{{ data.drugPricing.pharmacy.name }}</p>

      <label>NPI</label>
      <p class="value">{{ data.drugPricing.pharmacy.npi }}</p>

      <label>Phone Number</label>
      <p class="value">{{ data.drugPricing.pharmacy.phoneNumber }}</p>

      <label>NABP</label>
      <p class="value">{{ data.drugPricing.pharmacy.nabp }}</p>

      <label>Network Pharmacy</label>
      <p class="value">
        {{ data.drugPricing.pharmacy.inNetwork ? "Yes" : "No" }}
      </p>

      <label>Distance (in Miles)</label>
      <p class="value">
        {{ data.drugPricing.pharmacy.distance || "-" }}
      </p>
    </div>

    <div class="mat-6">
      <label>Pharmacy Address</label>
      <p class="value">
        {{ data.drugPricing.pharmacy.address.addressLine1 }},
        {{
        data.drugPricing.pharmacy.address.addressLine2
        ? data.drugPricing.pharmacy.address.addressLine2 + ","
        : ""
        }}
        {{ data.drugPricing.pharmacy.address.city }},
        {{ data.drugPricing.pharmacy.address.state }},
        {{ data.drugPricing.pharmacy.address.zipCode }}
      </p>

      <label>Hours of Operation</label>
      @if (data.drugPricing.pharmacy.hours.operating24Hours) {
        <p>
          Operating 24 hours
        </p>
      }
      @if (!data.drugPricing.pharmacy.hours.operating24Hours) {
        @for (day of days; track day) {
          <p class="capitalize mb-0 title-12 week-block" [hidden]="!getDay(day)">
            <span class="day-time">{{ day | titlecase }}&nbsp;</span>
            <span>{{ getDay(day) }}</span>
          </p>
        }
      }

      <label>Pharmacy Services</label>
      <p class="value">
        {{ data.drugPricing.pharmacy.services?.join(", ") }}
      </p>
    </div>
  </div>
</div>
<div class="mapouter">
  <app-google-map [pharmacy]="data.drugPricing.pharmacy"></app-google-map>
</div>
</div>
</div>
<!-- TEMPLATES -->
<ng-template let-rejectMsg="rejectMsg" #rejectMsgTemplate>
  @if (rejectMsg) {
    <div class="d-flex align-items-center mb-1">
      <img src="/assets/images/warning-icon-orange.svg"  alt="Warning" class="warning mr-1" />
      <p class="reject-msg text-danger ">
        {{ getDisplayRejectMessage(rejectMsg) | async }}
      </p>
    </div>
  }
</ng-template>


<ng-template let-memberResponsibility="memberResponsibility" #pricingTemplate>
  <label>
    Estimated Member Responsibility
  </label>
  <p>
    {{ memberResponsibility ? '$' + memberResponsibility : '$-' }}
  </p>
</ng-template>

